export const CMS_STORE_NAME = 'cms';
export const CMS_ACTIONS_NAME = 'CMS';
